<template>
  <div class="search-page" :class="['search-page', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <common-title titleName="搜索"  :zIndex="1000"></common-title>
    <!-- 顶部搜索栏 -->
    <div class="search-header">
      <div class="search-input-box">
        <img
          class="search-icon"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/boolMall/search.png"
          alt="搜索"
        />
        <input
          ref="searchInput"
          v-model="keyword"
          placeholder="请输入图书名称"
          class="search-input"
          @keyup.enter="handleSearch"
        />
        <button
          v-if="keyword"
          class="clear-btn"
          @click="clearKeyword"
        ></button>
      </div>
      <button class="search-btn" @click="handleSearch">搜索</button>
    </div>

    <!-- 搜索内容区 -->
    <div ref="searchContent" class="search-content" @scroll="handleSearchScroll">
      <div v-if="!keyword" class="search-default">
        <!-- 搜索历史 -->
        <div class="history-search">
          <div class="history-header"  v-if="historyList.length" >
            <h3 class="title">搜索记录</h3>
            <button class="del-btn" @click="clearHistory"></button>
          </div>
          <div class="history-list">
            <span
              class="history-item"
              v-for="(item, index) in historyList"
              :key="index"
              @click="handleHistoryClick(item)"
            >
              {{ item }}
            </span>
          </div>
        </div>
      </div>
      <div v-else class="goods-list">
        <template v-if="goodsList.length">
          <BookCard
            v-for="(item, index) in goodsList"
            :key="item.packageId || item.productId || index"
            :item="item"
            @click="goBookDetail"
          />
          <p v-if="goodsList.length > 10" class="goods-list-end">没有更多课程了！</p>
        </template>
        <EmptyData v-else-if="searchListLoaded" :emptyName="'noProductList'" />
      </div>
    </div>
  </div>
</template>

<script>
import BookCard from './components/BookCard.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { reqBookMallList, reqSearchHistoryList, reqDelSearchHistory } from '@/api/bookMall';
import { resetProductData, resetCoursePackage } from '@/utils/tools';
import { reqProductsNew } from '@/api/home';
import { reqCombinationlist } from '@/api/combination';
import { BOOK_MALL_HOME_RECOMMEND_ID } from './constants/bookMallFilterOptions';
import { isLogin } from '@/utils/common';

export default {
  name: 'SearchPage',
  components: {
    BookCard,
    EmptyData,
  },
  data() {
    return {
      keyword: '', // 搜索关键词
      // 搜索历史
      historyList: [],
      goodsList: [],
      /** 本次搜索请求结束后才展示缺省，避免未搜索时闪一下 */
      searchListLoaded: false,
      searchPageNum: 1,
      searchPageSize: 20,
      hasMoreSearchList: true,
      searchLoading: false,
    };
  },
  created() {
    // 页面加载获取历史记录
    this.getHistory();
  },
  mounted() {
    this.focusSearchInput();
    localStorage.setItem('miniBeforePageName', 17);
    document.title="图书商城"
  },
  activated() {
    this.focusSearchInput();
  },
  methods: {
    focusSearchInput() {
      this.$nextTick(() => {
        const el = this.$refs.searchInput;
        if (el && el.focus) el.focus();
      });
    },
    async handleSearch() {
      if (!this.keyword) return;
      this.searchPageNum = 1;
      this.hasMoreSearchList = true;
      this.searchListLoaded = false;
      this.goodsList = [];
      await this.fetchSearchList();
    },
    async fetchSearchList() {
      if (!this.keyword || this.searchLoading) return;
      if (this.searchPageNum > 1 && !this.hasMoreSearchList) return;
      const parmas = {
        baseBusinessLine: 1,
        homeRecommendId: BOOK_MALL_HOME_RECOMMEND_ID,
        keyword: this.keyword,
        pageNum: this.searchPageNum,
        pageSize: this.searchPageSize,
      };
      this.searchLoading = true;
      try {
        const { code, data } = await reqBookMallList(parmas);
        if (code === 0) {
          const pageData = data?.recommendContentPageVO || {};
          const list = pageData.data || [];
          const pageNum = pageData.pageNum || this.searchPageNum;
          const pages = pageData.pages || 0;
          this.hasMoreSearchList = pageNum < pages;
          this.getHistory();
          if (!list.length) {
            if (this.searchPageNum === 1) {
              this.goodsList = [];
            }
            this.searchListLoaded = true;
            return;
          }
          this.getMajorList(list, 'goodsList', this.searchPageNum > 1);
        } else {
          if (this.searchPageNum === 1) {
            this.goodsList = [];
          }
          this.searchListLoaded = true;
        }
      } finally {
        this.searchLoading = false;
      }
    },
    clearKeyword() {
      this.keyword = '';
      this.goodsList = [];
      this.searchListLoaded = false;
      this.searchPageNum = 1;
      this.hasMoreSearchList = true;
    },
    // 点击历史搜索
    handleHistoryClick(val) {
      this.keyword = val;
      this.handleSearch();
    },
    loadMoreSearchList() {
      if (this.searchLoading || !this.hasMoreSearchList || !this.keyword) return;
      this.searchPageNum += 1;
      this.fetchSearchList();
    },
    handleSearchScroll() {
      if (this.searchLoading || !this.hasMoreSearchList) return;
      const el = this.$refs.searchContent;
      if (!el) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 80) {
        this.loadMoreSearchList();
      }
    },
    goBookDetail(item) {
      sessionStorage.setItem('back',true)
      if (item.setType === 1) {
        this.$router.push({
          path: '/combinationCourse',
          query: { combinationId: item.packageId },
        });
        return;
      }
      this.$router.push({
        path: '/courseDetail',
        query: { courseId: item.productId },
      });
    },
    // 获取历史记录（需登录，未登录不调接口）
    async getHistory() {
      if (!isLogin()) {
        this.historyList = [];
        return;
      }
      const { code, data } = await reqSearchHistoryList(BOOK_MALL_HOME_RECOMMEND_ID);
      if (code === 0) {
        this.historyList = (data || []).slice(-10);
      }
    },
    // 清空历史记录
    clearHistory() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认清空历史搜索吗？',
          confirmButtonText: '是',
          cancelButtonText: '否',
        })
        .then(async () => {
          const { code, msg } = await reqDelSearchHistory({
            homeRecommendId:BOOK_MALL_HOME_RECOMMEND_ID
          });
          if (code === 0) {
            this.historyList = [];
            this.$toast('删除成功！');
          } else {
            this.$toast(msg || '删除失败');
          }
        })
        .catch(() => {});
    },
    // 与 bookMall/index.vue 的 getMajorList 保持一致
    getMajorList(recommendContentVOList, listKey = 'goodsList', isAppend = false) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProductsNew(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};
      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = resetProductData(res?.data || [], 2);
        const resPackage = resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this[listKey] = isAppend ? [...this[listKey], ...allCourse] : allCourse;
        if (listKey === 'goodsList') {
          this.searchListLoaded = true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.inApp {
  padding-top: 20px !important;
}

.search-page {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  padding-top: 101px;
 background: #F7F8FC;
}

// 顶部搜索栏
.search-header {
  display: flex;
  align-items: center;
  padding: 29px 36px;

  .search-input-box {
    position: relative;
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    min-width: 0;

    .search-icon {
      position: absolute;
      left: 22px;
      width: 22px;
      height: 22px;
    }

    .search-input {
      width: 100%;
      height: 72px;
      padding-left: 56px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 72px;
      background: #fff;
      border-radius: 36px;
    }

    .clear-btn {
      position: absolute;
      top: 50%;
      right: 20px;
      width: 29px;
      height: 29px;
      background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/boolMall/close.png')
        no-repeat center;
      background-size: 100% 100%;
      border: none;
      transform: translateY(-50%);
    }
  }

  .search-btn {
    flex: 0 0 auto;
    margin-left: 22px;
    color: #ff7f41;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
    background: none;
  }
}

// 内容区
.search-content {
  flex: 1;
  padding: 0 36px 16px 36px;
  overflow-y: auto;

  // 默认搜索区
  .search-default {
    .history-search {
      .history-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 25px;
        .title {
          color: #333;
          font-weight: 500;
          font-size: 33px;
          line-height: 45px;
        }

        .del-btn {
          width: 43px;
          height: 43px;
          background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/boolMall/delete.png');
          background-size: 100%;
        }
      }

      .history-list {
        display: flex;
        flex-wrap: wrap;
        gap: 22px;

        .history-item {
          height: 51px;
          padding: 0 18px;
          color: #333;
          font-weight: 400;
          font-size: 25px;
          line-height: 51px;
          border: 2px solid #e7e7e7;
          border-radius: 7px;
        }
      }
    }
  }

  ::v-deep .emptyIndent {
    height: fit-content !important;
    padding: 50px 0;

    .product {
      display: none;
    }
  }
}
.goods-list{
  .book-card{
    margin-bottom: 22px;
  }
  .goods-list-end {
    margin: 0 0 36px;
    color: rgba(153, 153, 153, 1);
    font-size: 25px;
    line-height: 36px;
    text-align: center;
  }
}
</style>
